<template>
    <be-form-group v-bind="widgetProps">
        <be-loading :active="!options">
            <vue-multiselect
                taggable
                multiple
                close-on-select
                clear-on-select
                :show-no-options="false"
                :disabled="disabled || !options"

                tag-placeholder=""
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder=""

                :options="optionsAndTags"
                :value="value"

                @input="handleInput"
                @tag="addTag"
            >
                <span slot="noResult">Keine Option gefunden.</span>

                <template slot="caret" slot-scope="{ toggle }">
                    <div @mousedown.prevent.stop="toggle()" class="multiselect__select">
                        <i class="mdi mdi-chevron-down"></i>
                    </div>
                </template>
            </vue-multiselect>
        </be-loading>
    </be-form-group>
</template>

<script>
    import VueMultiselect from 'vue-multiselect';
    import arrayUniq from 'array-uniq';
    import widget from '../../mixins/widget';

    import 'vue-multiselect/dist/vue-multiselect.min.css';

    export default {
        mixins: [widget],
        components: { VueMultiselect },

        props: {
            options: Array,
        },

        computed: {
            optionsAndTags: vm => arrayUniq((vm.value && vm.options) ? vm.value.concat(vm.options) : (vm.options || [])),
        },

        methods: {
            addTag(v) {
                const values = this.value;
                values.push(v);

                this.$emit('input', values);
            },

            handleInput(v) {
                this.$emit('input', v);
            },
        },
    };
</script>

<style lang="scss">
    @import "../../assets/styles/multiselect";
</style>
